import React from 'react'
import styled from 'styled-components'
import { Appear } from 'mdx-deck'

import cohesion from '!!file-loader!../images/Cohesion.png';
import cohesion2 from '!!file-loader!../images/Cohesion-abominable.png';
import cohesion3 from '!!file-loader!../images/Cohesion-focus.png';

const FixedImage = styled.img`
  background-size:contain;
  position: absolute;
  width: 60vw;
  left: 20vw;
`;

const Wrapper = styled.a`
  height: 100vh;
  width: 100vw;
  position: relative;
`

export default class Tweet extends React.Component {
    render() {

        return <Wrapper>
            <FixedImage src={cohesion}></FixedImage>
            <Appear>
                <FixedImage src={cohesion2}></FixedImage>
                <FixedImage src={cohesion3}></FixedImage>
            </Appear>
        </Wrapper>;
    }
}
